/* =============================================================================
   TPW v7 · Final C runtime (19 Oct 2026). House code, no libraries.
   1 Counter dispatch flaps + every "ships" line  (window.TPWStoreHours, Melbourne)
   2 Free-shipping gauges from the after-discount cart total (/cart.js)
   3 One-tap adds  -> /cart/add.js -> refresh the THEME drawer -> open it
   4 Best sellers chips (server-rendered templates, swapped in place)
   5 Rails (buttons, hero product de-duplicated)
   6 Deal end dates re-checked on the client (page cache): hide on time, never restart
   7 Restock size chips
   8 PDP receipt (tap to add, totals, one add for pipe + add-ons)
   9 Collection line-up tiles + price ruler through the theme's FacetFiltersForm
   Motion: transform/opacity only; prefers-reduced-motion = instant.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__tpwV7) return;
  window.__tpwV7 = true;

  var CFG = window.TPW_V7 || {};
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function money(c) {
    c = Math.max(0, Math.round(c));
    var d = Math.floor(c / 100), s = String(d).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + s + '.' + pad2(c % 100);
  }
  function moneyShort(c) { return c % 100 === 0 ? '$' + String(c / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : money(c); }

  /* ------------------------------------------------------------ 1 dispatch */
  var DAYS = { Mon: 'MON', Tue: 'TUE', Wed: 'WED', Thu: 'THU', Fri: 'FRI', Sat: 'SAT', Sun: 'SUN' };
  function dispatchState() {
    var S = window.TPWStoreHours; if (!S) return null;
    var now = new Date();
    var d = S.dispatchETA(now);
    var cut = S.fmtClock12(S.CUTOFF_HOUR);
    if (d.sameDay) {
      var secs = d.secondsToCutoff, h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60);
      return { same: true, h: h, m: m, cut: cut, label: 'SHIPS TODAY',
        line: 'Order by ' + cut + ', ships today',
        aria: h + ' hours ' + m + ' minutes left for same day dispatch' };
    }
    var p = S.melbParts(now);
    var rel = d.relative; // 'tomorrow' | weekday
    var dayWord = rel === 'tomorrow' ? 'TOMORROW' : S.fmtWeekdayLong(d.shipParts).toUpperCase();
    var sub;
    if (S.isPublicHoliday(now)) sub = 'public holiday today';
    else if (p.dow === 6 || p.dow === 0 || (p.dow === 5 && p.h >= S.CUTOFF_HOUR)) sub = 'order any time this weekend';
    else sub = 'order any time tonight';
    return { same: false, day: DAYS[d.shipParts.wd] || 'MON', cut: cut, label: 'SHIPS ' + dayWord, sub: sub,
      line: 'Order now, ships ' + (rel === 'tomorrow' ? 'tomorrow' : S.fmtWeekdayLong(d.shipParts)),
      aria: 'Next dispatch ' + (rel === 'tomorrow' ? 'tomorrow' : S.fmtWeekdayLong(d.shipParts)) };
  }
  function paintDispatch() {
    var st = dispatchState(); if (!st) return;
    $$('[data-v7-ship-text]').forEach(function (el) { el.textContent = st.line; });
  }
  function scheduleDispatch() {
    var now = Date.now(), ms = 60000 - (now % 60000) + 50;
    setTimeout(function () { paintDispatch(); scheduleDispatch(); }, ms);
  }

  /* --------------------------------------------------------------- 2 gauge */
  var cartTotal = null;
  function paintGauges(total) {
    if (typeof total === 'number') cartTotal = total;
    $$('[data-v7-gauge]').forEach(function (g) {
      var th = +g.getAttribute('data-th') || 15000;
      var base = cartTotal !== null ? cartTotal : (+g.getAttribute('data-total') || 0);
      var t = base + (+g.getAttribute('data-extra') || 0);
      var free = t >= th;
      g.classList.toggle('is-free', free); g.classList.toggle('is-empty', t === 0);
      var txt = $('[data-v7g-txt]', g), fill = $('[data-v7g-fill]', g);
      if (txt) txt.innerHTML = free ? 'Free shipping on this order' : '<b>' + money(th - t) + '</b> to free shipping';
      if (fill) fill.style.transform = 'scaleX(' + Math.min(1, t / th).toFixed(3) + ')';
    });
    // The delivery line shares the gauge's basis (after-discount total vs the free-shipping rate) and its strings come from locales.
    $$('[data-v7-deliv]').forEach(function (d) {
      var th = +d.getAttribute('data-th') || 15000;
      var t = cartTotal !== null ? cartTotal : (+d.getAttribute('data-total') || 0);
      var txt = $('[data-v7dl-t]', d), s = d.getAttribute(t >= th ? 'data-hi' : 'data-lo');
      if (txt && s && txt.textContent !== s) txt.textContent = s;
    });
  }
  var cartTimer;
  function refreshCart() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { paintGauges(c.total_price); })
        .catch(function () {});
    }, 120);
  }
  function isCartWrite(u) { u = typeof u === 'string' ? u : (u && u.url) || ''; return /\/cart\/(add|change|update|clear)/.test(u); }
  function isCartAdd(u) { u = typeof u === 'string' ? u : (u && u.url) || ''; return /\/cart\/add/.test(u); }
  (function hook() {
    var of = window.fetch;
    if (of) window.fetch = function (a, o) {
      var p = of.apply(this, arguments);
      if (isCartWrite(a)) p.then(function (r) {
        refreshCart();
        if (isCartAdd(a) && r && r.ok && r.clone) r.clone().json().then(added).catch(function () { added(null); });
      }).catch(function () {});
      return p;
    };
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__v7u = u; return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (isCartWrite(this.__v7u)) {
        var x = this, u = this.__v7u;
        this.addEventListener('load', function () {
          refreshCart();
          if (isCartAdd(u) && x.status >= 200 && x.status < 300) { var j = null; try { j = JSON.parse(x.responseText); } catch (e) {} added(j); }
        });
      }
      return xs.apply(this, arguments);
    };
  })();

  /* ------------------------------------------- R4: add confirmation (founder rule: the drawer never auto-opens) */
  // Every successful /cart/add (card +, PDP, hero, bundle, setup rows, search) ends in the same two signals: the header
  // count bumps and a slim toast says what was added. PREPUB 21 Oct (CRO W6): primary = Checkout (ink on white button), secondary = View cart (opens the drawer).
  var toastT, lastAdd = 0;
  /* R8 (Director 12): an add button answers the tap at 0ms (pressed + spinner) and lets go when the server answers. */
  var PRESS = '.tpwc__qa:not([data-tpwc-choose]),.tpwc__plus,[data-tpsd-add],[data-v7-add],.v7-buynow,.sbx-add,[data-sbx-add],.tps-card-add__btn,[data-v7-add-many],[data-setup-go]';
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(PRESS);
    if (!b || b.disabled) return;
    b.classList.add('v7-pressed');
    clearTimeout(b.__v7pt); b.__v7pt = setTimeout(function () { b.classList.remove('v7-pressed'); }, 5000);
  }, true);
  function unpress() { $$('.v7-pressed').forEach(function (b) { b.classList.remove('v7-pressed'); }); }
  function added(j) {
    unpress();
    if (Date.now() - lastAdd < 400) return; lastAdd = Date.now();
    var it = j && (j.items ? j.items[0] : j), n = j && j.items ? j.items.length : 1;
    var name = it && (it.product_title || it.title) || '';
    // a setup set was part of this add (assets/tpw-cfg.js leaves the note): say "Setup added to cart", never one piece's name or a count
    var mk = window.__tpwsAdd, isSet = !!(mk && mk.label && Date.now() - mk.t < 8000);
    if (isSet) { name = mk.label; n = 1; window.__tpwsAdd = null; }
    bumpCount();
    showToast(name, n, isSet);
  }
  function bumpCount() {
    fetch('/?sections=cart-icon-bubble', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (secs) {
        var b = document.getElementById('cart-icon-bubble');
        if (b && secs['cart-icon-bubble']) { var t = document.createElement('div'); t.innerHTML = secs['cart-icon-bubble']; var f = t.querySelector('.shopify-section') || t.firstElementChild; if (f) b.innerHTML = f.innerHTML; }
        if (b) { b.classList.remove('v7-bump'); void b.offsetWidth; b.classList.add('v7-bump'); }
      }).catch(function () {});
  }
  function showToast(name, n, isSet) {
    var t = document.getElementById('v7-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'v7-toast'; t.className = 'v7-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
      t.innerHTML = '<span class="v7-toast__ok" aria-hidden="true"></span><span class="v7-toast__t"></span><a class="v7-toast__a" href="/cart" data-cart-open>View cart</a><a class="v7-toast__go" href="/checkout">Checkout</a><button type="button" class="v7-toast__x" aria-label="Dismiss">&times;</button>';
      document.body.appendChild(t);
      t.querySelector('.v7-toast__x').addEventListener('click', hideToast);
      t.querySelector('.v7-toast__a').addEventListener('click', function (e) {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') { e.preventDefault(); window.__v7UserOpen = Date.now(); hideToast(); d.open(this); }
      });
      t.addEventListener('mouseenter', function () { clearTimeout(toastT); });
      t.addEventListener('focusin', function () { clearTimeout(toastT); });
      t.addEventListener('mouseleave', armToast);
    }
    // a setup add reads as one phrase ("Setup added to cart", the tpw_cfg.toast label), never "Added · Setup added to cart"
    if (isSet && name) { t.querySelector('.v7-toast__t').innerHTML = '<b class="v7-toast__nm"></b>'; }
    else t.querySelector('.v7-toast__t').innerHTML = '<b>Added</b>' + (name ? '<span class="v7-toast__dot" aria-hidden="true"> &middot; </span><span class="v7-toast__nm"></span>' : '') + (n > 1 ? '<span class="v7-toast__dot v7-toast__cnt" aria-hidden="true"> &middot; </span><span class="v7-toast__cnt">' + n + ' items</span>' : '');
    t.querySelector('.v7-toast__t').classList.toggle('is-set', !!isSet);
    t.classList.toggle('is-set', !!isSet);
    var nm = t.querySelector('.v7-toast__nm'); if (nm) nm.textContent = name;
    // Hermes #4: sit just BELOW the visible header so the cart icon + count bump stay in view (never over the header)
    var hb = 0, hw = document.querySelector('sticky-header, .header-wrapper');
    if (hw) { var hr = hw.getBoundingClientRect(); if (hr.bottom > 0) hb = hr.bottom; }
    t.style.top = Math.round(Math.max(hb, 0) + 10) + 'px';
    t.classList.add('is-on');
    armToast();
  }
  function armToast() { clearTimeout(toastT); toastT = setTimeout(hideToast, 6000); }   /* PREPUB 21 Oct (CRO W6): Checkout is the primary action, so the toast holds 6s */
  function hideToast() { var t = document.getElementById('v7-toast'); if (t) t.classList.remove('is-on'); }

  /* ---------------------------------------------------------------- 3 adds */
  function drawerRefreshAndOpen(trigger, open) {
    var d = document.querySelector('cart-drawer');
    return fetch('/?sections=cart-icon-bubble,cart-drawer', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (secs) {
        window.__tpwCartHandled = Date.now();
        if (d && typeof d.renderContents === 'function') d.renderContents({ sections: secs });
        else {
          var b = document.getElementById('cart-icon-bubble');
          if (b && secs['cart-icon-bubble']) { var t = document.createElement('div'); t.innerHTML = secs['cart-icon-bubble']; var f = t.querySelector('.shopify-section') || t.firstElementChild; if (f) b.innerHTML = f.innerHTML; }
        }
        if (open && d && typeof d.open === 'function') {
          setTimeout(function () { d.__userOpen = true; try { d.open(trigger); } finally { d.__userOpen = false; } paintGauges(null); }, 40);
        }
      });
  }
  function say(msg) {
    var n = document.getElementById('v7-status');
    if (!n) { n = document.createElement('p'); n.id = 'v7-status'; n.className = 'visually-hidden'; n.setAttribute('role', 'status'); document.body.appendChild(n); }
    n.textContent = ''; setTimeout(function () { n.textContent = msg; }, 30);
  }
  function addItems(items, btn) {
    if (!items.length) return Promise.resolve();
    if (btn && btn.getAttribute('aria-busy') === 'true') return Promise.resolve();
    window.__tpwCartHandled = Date.now();
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.setAttribute('aria-disabled', 'true'); }
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function () {
      if (btn) {
        btn.classList.add('is-done');
        var lbl = btn.getAttribute('data-v7-label');
        if (lbl) btn.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-done'); if (lbl) btn.innerHTML = lbl; }, 1800);
      }
      say(items.length > 1 ? items.length + ' items added to cart' : 'Added to cart');
      return drawerRefreshAndOpen(btn, CFG.openDrawer === true);
    }).catch(function (err) {
      var msg = (err && (err.description || err.message)) || 'Could not add. Please try again.';
      say(msg);
      if (btn) {
        var lbl = btn.getAttribute('data-v7-label');
        if (lbl) { btn.textContent = String(msg).slice(0, 60); setTimeout(function () { btn.innerHTML = lbl; }, 2600); }
        else btn.setAttribute('title', msg);
      }
    }).then(function () {
      if (btn) { btn.removeAttribute('aria-busy'); btn.removeAttribute('aria-disabled'); }
    });
  }
  document.addEventListener('click', function (e) {
    var one = e.target.closest('[data-v7-add]');
    if (one) { e.preventDefault(); addItems([{ id: +one.getAttribute('data-v7-add'), quantity: 1 }], one); return; }
    var many = e.target.closest('[data-v7-add-many]');
    if (many) {
      e.preventDefault();
      var ids = many.getAttribute('data-v7-add-many').split(',').filter(Boolean);
      addItems(ids.map(function (id) { return { id: +id, quantity: 1 }; }), many);
    }
  });

  /* ------------------------------------------------------------ 6 sale end */
  function melbEnd(raw) {
    // returns epoch ms of the end instant. date only -> 23:59:59 Melbourne that day.
    if (!raw) return null;
    if (raw.length > 10) { var t = Date.parse(raw); return isNaN(t) ? null : t; }
    var S = window.TPWStoreHours; if (!S) return null;
    var guess = Date.parse(raw + 'T23:59:59Z'); if (isNaN(guess)) return null;
    // walk the guess by the Melbourne offset so the wall clock reads 23:59:59 on that date
    var p = S.melbParts(new Date(guess));
    var wall = Date.UTC(p.y, p.m - 1, p.d, p.h, p.mn, p.s);
    return guess - (wall - guess);
  }
  function paintEnds() {
    var now = Date.now();
    $$('[data-v7-ends]').forEach(function (el) {
      var end = melbEnd(el.getAttribute('data-v7-ends')); if (!end) return;
      var left = end - now;
      if (left <= 0) {
        var hero = el.closest('[data-v7-hero]');
        if (hero) {
          var tpl = $('template[data-v7-hero-plain]', hero);
          if (tpl) { hero.innerHTML = tpl.innerHTML; hero.classList.remove('v7-hero--deal'); hero.classList.add('v7-hero--plain'); hero.removeAttribute('data-v7-hero-product'); }
        } else el.hidden = true;
        return;
      }
      if (left <= 48 * 3600 * 1000) {
        var h = Math.floor(left / 3600000), m = Math.floor((left % 3600000) / 60000);
        el.textContent = 'Deal ends in ' + pad2(h) + 'h ' + pad2(m) + 'm';
      }
    });
  }

  /* ------------------------------------------- founder rule: no auto-open */
  // The drawer opens only from a shopper's own tap on the cart icon or a /cart link (26 Jun rule, kept on TPW).
  // Any programmatic open (add-to-cart paths in pdpv9, cart.js, quick add) is ignored unless it follows such a tap.
  (function () {
    if (CFG.openDrawer === true) return;
    document.addEventListener('click', function (e) {
      if (e.target.closest('#cart-icon-bubble, .header-cart__link, a[href="/cart"], [data-cart-open]')) window.__v7UserOpen = Date.now();
    }, true);
    function patch() {
      var C = window.customElements && customElements.get('cart-drawer');
      if (!C || C.prototype.__v7Patched) return !!C;
      var orig = C.prototype.open;
      C.prototype.open = function () {
        if (Date.now() - (window.__v7UserOpen || 0) > 1500) return;
        hideToast();   // R8: never a toast over the header while the drawer is open
        return orig.apply(this, arguments);
      };
      C.prototype.__v7Patched = true;
      return true;
    }
    if (!patch() && window.customElements) customElements.whenDefined('cart-drawer').then(patch);
  })();

  /* ------------------------------------------- PDP: ledger dispatch + description clamp */
  function paintLedger() {
    var S = window.TPWStoreHours; if (!S) return;
    var d = S.dispatchETA(new Date());
    $$('[data-v7-ledger-ship]').forEach(function (el) {
      if (d.sameDay) { var h = Math.floor(d.secondsToCutoff / 3600), m = Math.floor((d.secondsToCutoff % 3600) / 60); el.textContent = 'Leaves Melbourne today if you order in the next ' + (h ? h + ' hr ' : '') + m + ' min'; }
      else el.textContent = 'Leaves Melbourne ' + (d.relative === 'tomorrow' ? 'tomorrow' : 'on ' + S.fmtWeekdayLong(d.shipParts)) + ', Australia Post tracked';
    });
  }
  function initClamp() {
    $$('[data-v7-clamp]').forEach(function (c) {
      var btn = c.parentNode.querySelector('[data-v7-clamp-more]');
      if (c.scrollHeight <= c.clientHeight + 24) { c.classList.add('is-short'); return; }
      if (!btn) return;
      // R3 (PDP-MIDAS-2 #3): end the clamp on a whole block, never mid-bullet, never on a heading whose body is hidden
      var body = c.firstElementChild, lim = c.clientHeight, top = c.getBoundingClientRect().top, cut = 0;
      var blocks = [];
      (function walk(el) { [].forEach.call(el.children, function (k) { if (/^(UL|OL)$/.test(k.tagName)) [].forEach.call(k.children, function (li) { blocks.push(li); }); else if (/^(DIV|SECTION)$/.test(k.tagName) && k.children.length) walk(k); else blocks.push(k); }); })(body || c);
      for (var i = 0; i < blocks.length; i++) {
        var r = blocks[i].getBoundingClientRect(), b = r.bottom - top;
        if (b > lim) break;
        if (!/^H[1-6]$/.test(blocks[i].tagName)) cut = Math.ceil(b);
      }
      if (cut > 120) c.style.maxHeight = cut + 'px';
      btn.hidden = false;
      var shut = c.style.maxHeight;
      btn.addEventListener('click', function () { var o = c.classList.toggle('is-open'); c.style.maxHeight = o ? 'none' : shut; btn.setAttribute('aria-expanded', o ? 'true' : 'false'); btn.textContent = o ? 'Less' : 'More'; });
    });
  }

  /* ------------------------------------------- R6: /cart "Add to your setup" + (outside the drawer, which wires its own) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-v7-cart-rail] [data-tpsd-add]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-tpsd-add'), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; setTimeout(function () { location.reload(); }, 700); })
      .catch(function () { b.removeAttribute('aria-busy'); });
  });

  /* ------------------------------------------- R15 (Argus E-11): closed desktop submenus are out of the tab order */
  // A submenu (hover menu) is inert until its top item is hovered, focused, or opened with ArrowDown; Tab then moves top
  // item to top item instead of walking ~45 hidden links. Escape closes and returns focus.
  function initMenuInert() {
    if (!('inert' in HTMLElement.prototype)) return;
    $$('.header-inline-menu__item.list-menu--submenu').forEach(function (li) {
      var top = li.querySelector('.header-inline-menu__item-link'), sub = li.querySelector('.header-submenu');
      if (!top || !sub) return;
      var t;
      function open() { clearTimeout(t); sub.inert = false; }
      function shut() { t = setTimeout(function () { if (!li.matches(':hover') && !li.contains(document.activeElement)) sub.inert = true; }, 120); }
      sub.inert = true;
      li.addEventListener('mouseenter', open); li.addEventListener('mouseleave', shut);
      li.addEventListener('focusout', shut);
      // Argus RESET P2: an item opened by keyboard focus (its panel shows on :focus-within) lets Tab walk INTO its panel's
      // links, then on to the next item; Escape still closes and returns to the item
      top.addEventListener('focus', open);
      top.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(); var f = sub.querySelector('a'); if (f) f.focus(); }
      });
      sub.addEventListener('keydown', function (e) { if (e.key === 'Escape') { sub.inert = true; top.focus(); } });
    });
  }

  /* ------------------------------------------- PDP: thousands comma (R4, Midas "$1 , 499") */
  // The headline dollars run is DM Mono: a comma takes a full monospace cell. Wrap it in a tight span on first paint
  // (Liquid) and again whenever the price script rewrites the run (variant change / roll).
  function initPriceComma() {
    $$('.pdpv9 [data-price]').forEach(function (pr) {
      function fix() {
        var d = pr.querySelector('[data-price-d]');
        if (!d || d.querySelector('.pd-c') || d.children.length || d.textContent.indexOf(',') < 0) return;
        d.innerHTML = d.textContent.replace(/,/g, '<span class="pd-c">,</span>');
      }
      fix();
      if (window.MutationObserver) new MutationObserver(function () { setTimeout(fix, 0); }).observe(pr, { childList: true, subtree: true, characterData: true });
    });
  }

  /* ------------------------------------------- PDP: Buy it now (TPW ghost, R3) */
  function initBuyNow() {
    $$('[data-v7-buynow]').forEach(function (b) {
      var form = b.closest('form');
      if (!form) return;
      var atc = form.querySelector('[data-atc]');
      // mirror the add button's availability (variant changes toggle it)
      if (atc && window.MutationObserver) new MutationObserver(function () { b.disabled = atc.disabled; }).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
      b.addEventListener('click', function () {
        var id = form.querySelector('[name="id"]'), q = form.querySelector('[name="quantity"]');
        if (!id || !id.value) return;
        b.classList.add('is-busy');
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +id.value, quantity: Math.max(1, +(q && q.value) || 1) }] })
        }).then(function (r) { if (!r.ok) throw r; location.assign('/checkout'); })
          .catch(function () { b.classList.remove('is-busy'); if (atc) atc.click(); });
      });
    });
  }

  /* ------------------------------------------- line-up tile row: edge fade */
  function initTileFade() {
    $$('.lu-tiles').forEach(function (r) {
      function upd() { var max = r.scrollWidth - r.clientWidth; r.classList.toggle('is-more', max > 2 && r.scrollLeft < max - 2); }
      r.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
  }

  /* ---------------------------------------------------------------- boot */
  function boot() {
    paintDispatch(); scheduleDispatch();
    paintGauges(null);
    paintEnds(); setInterval(paintEnds, 30000);
    initTileFade();
    paintLedger(); setInterval(paintLedger, 60000);
    initClamp();
    initBuyNow();
    initPriceComma();
    initMenuInert();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { paintDispatch(); paintEnds(); refreshCart(); } });
    // the drawer re-renders its markup on every change: re-apply the gauge from the live total
    var d = document.querySelector('cart-drawer');
    if (d && window.MutationObserver) new MutationObserver(function () { if (cartTotal !== null) paintGauges(null); }).observe(d, { childList: true, subtree: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* 20 Oct (Director 12, drawer refresh): phone bottom sheet, swipe down on the handle/header to close. transform only. */
(function () {
  var y0 = null, dy = 0, slip = null;
  function dr() { return document.querySelector('cart-drawer'); }
  document.addEventListener('touchstart', function (e) {
    var t = e.target.closest && e.target.closest('cart-drawer .tpsd-dh, cart-drawer .tpsd-v7g');
    if (!t || window.innerWidth >= 750) return;
    slip = t.closest('.tpsd-slip'); if (!slip) return;
    y0 = e.touches[0].clientY; dy = 0; slip.style.transition = 'none';
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (y0 === null || !slip) return;
    dy = Math.max(0, e.touches[0].clientY - y0);
    slip.style.transform = 'translateY(' + dy + 'px)';
  }, { passive: true });
  document.addEventListener('touchend', function () {
    if (y0 === null || !slip) return;
    slip.style.transition = ''; slip.style.transform = '';
    var d = dr();
    if (dy > 90 && d && typeof d.close === 'function') d.close();
    y0 = null; dy = 0; slip = null;
  });
})();

/* PDP pay-later line follows the selected variant (Themis ruling 26 Oct 2026). pdpv9.js rewrites the price element's
   data-price-cents on every variant change; the line re-checks the provider band (data-min / data-max, cents) and hides outside it.
   The Zip mark and the Zip row sit in [data-zip] and follow Zip's own band (data-zmin / data-zmax). Only when settings.bnpl_amount_line
   is on does the line carry an amount: price / 4 rounded UP to the cent, with "about" when the price does not divide by 4. When
   settings.spi_enabled is on, the id input inside Shopify's banner form follows the variant (change event so the banner re-reads it) and
   the banner hides under its own $50 floor (data-spi-min; it teases "orders over $50" there), with no upper cap.
   The drawer and /cart lines are server-rendered on every cart change. */
(function () {
  function fmt(c) { var s = (Math.floor(c) / 100).toFixed(2).split('.'); return '$' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + s[1]; }
  function boot() {
    var line = document.querySelector('.pdpv9 [data-v7-inst-line]'), pr = document.querySelector('.pdpv9 [data-price]');
    if (!line || !pr || !window.MutationObserver) return;
    var min = +line.getAttribute('data-min') || 0, max = +line.getAttribute('data-max') || 1e12;
    var zmin = +line.getAttribute('data-zmin') || 0, zmax = +line.getAttribute('data-zmax') || 1e12;
    var sheet = document.getElementById('v7-pl-sheet');
    var spiBox = document.querySelector('.pdpv9 [data-v7-spi]'), spiMin = spiBox ? +spiBox.getAttribute('data-spi-min') || 5000 : 0;
    var spi = document.querySelector('.pdpv9 [data-spi-id]'), vin = document.querySelector('.pdpv9-form [data-variant-input]');
    function apply() {
      var c = +pr.getAttribute('data-price-cents') || 0;
      var on = c >= min && c <= max;
      line.hidden = !on;
      if (on) {
        var a = line.querySelector('[data-bnpl-amt]');
        if (a) {
          a.textContent = fmt(Math.floor((c + 3) / 4));
          var pre = line.querySelector('[data-bnpl-pre]');
          if (pre) pre.textContent = pre.getAttribute(c % 4 ? 'data-pre-about' : 'data-pre-exact') || pre.textContent;
        }
      }
      if (spiBox) spiBox.hidden = c < spiMin;
      var zo = c >= zmin && c <= zmax;
      [line, sheet].forEach(function (r) { if (r) [].forEach.call(r.querySelectorAll('[data-zip]'), function (z) { z.hidden = !zo; }); });
      if (spi && vin && vin.value && spi.value !== vin.value) { spi.value = vin.value; spi.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    new MutationObserver(apply).observe(pr, { attributes: true, attributeFilter: ['data-price-cents'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* PDP pay-later explainer: a click on the backdrop closes it, and focus goes back to the line that opened it on every device
   (the native restore only runs for a keyboard or desktop-click open; a touch open on iOS leaves nothing to restore). The dialog's own
   padding also reports the dialog as the target, so a click closes only when it lands outside the dialog box. */
(function () {
  function boot() {
    var sheet = document.getElementById('v7-pl-sheet'), opener = document.querySelector('.pdpv9 .v7-pl__b');
    if (!sheet || !opener) return;
    sheet.addEventListener('click', function (e) {
      if (e.target !== sheet) return;
      var r = sheet.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) sheet.close();
    });
    sheet.addEventListener('close', function () { opener.focus({ preventScroll: true }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Director 12 (20 Oct): the drawer's setup grid never shows partial cards (see tpw-drawer.css .is-compact / .is-off).
   Measured on open, on every drawer re-render and on resize; class changes only, no layout writes in a loop. */
(function () {
  function fit() {
    var d = document.querySelector('cart-drawer'); if (!d || !d.classList.contains('active')) return;
    var rail = d.querySelector('.tpsd-rl'), db = d.querySelector('.tpsd-db'); if (!rail || !db) return;
    var cards = [].slice.call(rail.querySelectorAll('.tpsd-rc--card'));
    rail.classList.remove('is-compact', 'is-off', 'is-3up');
    cards.forEach(function (c) { c.hidden = false; });
    if (!cards.length) return;
    // TPW: "Add a note" now sits in the scroller under the grid, so its height is room the cards cannot use (TPS has no such node here)
    var noteBtn = db.querySelector('.tpsd-notebtn');
    var avail = db.getBoundingClientRect().bottom - rail.getBoundingClientRect().top - 16 - (noteBtn ? noteBtn.offsetHeight + 4 : 0);
    // whole rows only: 2-up, then 3-up (smaller cards), then one sideways row of small cards, then nothing
    var layouts = [[2, ''], [3, 'is-3up']];
    for (var k = 0; k < layouts.length; k++) {
      if (layouts[k][1]) rail.classList.add(layouts[k][1]);
      var rt = rail.getBoundingClientRect().top, c0 = cards[0].getBoundingClientRect();
      var head = c0.top - rt, rowH = c0.height, gap = 12;
      var rows = Math.floor((avail - head + gap) / (rowH + gap));
      if (rows >= 1) { cards.forEach(function (c, i) { if (i >= rows * layouts[k][0]) c.hidden = true; }); return; }
      if (layouts[k][1]) rail.classList.remove(layouts[k][1]);
    }
    rail.classList.add('is-compact');
    if (avail < rail.getBoundingClientRect().height - 16) rail.classList.add('is-off');
  }
  var t; function soon() { clearTimeout(t); t = setTimeout(function () { requestAnimationFrame(fit); }, 60); }
  function boot() {
    var d = document.querySelector('cart-drawer'); if (!d || !window.MutationObserver) return;
    new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) { if (m[i].type === 'childList' || m[i].attributeName === 'class' && m[i].target === d) { soon(); return; } } })
      .observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', soon);
    d.addEventListener('load', soon, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

